<template>
  <div>
    <div class="full-discounted">
      <b-container fluid>
        <div class="full-discounted-wrapper">
          <h1>{{ $t("payment.methods.freePayment.title") }}</h1>
          <h3>
            {{ $t("payment.methods.freePayment.description") }} {{ formattedAmount }}
            {{ $t("baht") }}
          </h3>
          <img src="/images/free.svg" :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"/>
          <b-spinner
            v-if="loading"
            label="Loading..."
            variant="'primary'"
          ></b-spinner>
          <b-button
            v-else
            class="discounted-button"
            @click="processPayment()"
            >{{ $t("payment.methods.freePayment.postItNow") }}</b-button
          >
        </div>
      </b-container>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import * as actionType from "../../../controllers/ActionTypes";
export default {
  name: "freePayment",
  props: {
    orderId: {
      type: Number,
      required: true
    },
    formattedAmount: {
      type: String,
      required: true
    },
    changeLoading: {
      type: Function,
      required: true
    },
    previousPendingPaymentId: {
      required: false,
      default: null
    },
    loading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  watch: {
    loading: function() {
      this.changeLoading(this.loading);
    }
  },
  methods: {
    ...mapActions("PaymentController", [actionType.PAY]),
    processPayment() {
      this.loading = true;
      var vm = this;
      vm.PAY({
        user_payment_id: vm.orderId
      })
        .then(function(response) {
          vm.$router.push({
            name: "PaymentSuccess",
            params: {
              id: vm.orderId,
              previousPendingPaymentId: vm.previousPendingPaymentId
            }
          });
        })
        .catch(function(error) {
          vm.$router.push({
            name: "PaymentSuccess",
            params: {
              id: vm.orderId,
              previousPendingPaymentId: vm.previousPendingPaymentId
            }
          });
        });
    }
  }
};
</script>
<style lang="scss" >
.full-discounted-wrapper {
  height: 100%;
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
  place-content: center space-around;
  align-items: center;
  width: 100%;
  h1 {
    color: var(--projectPrimaryColor) !important;
    margin: 20px 0;
  }
  h3 {
    color: #444444;
  }
  .discounted-button {
    font-size: 16px;
    @media (max-width: 992px) {
      font-size: 18px;
    }
    width: 225px;
    background: var(--projectPrimaryColor) !important;
    color: $white;
    border-radius: var(--borderRadius);
    border: 1px solid var(--projectPrimaryColor) !important;
    height: 40px;
    margin: 20px 0;
    @media (max-width: 992px) {
      font-size: 18px;
    }
  }
  span {
    color: var(--projectPrimaryColor) !important;
    margin: 20px 0;
  }
}
</style>